import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=e31c9efe&scoped=true"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"
import style0 from "./LegalPage.vue?vue&type=style&index=0&id=e31c9efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31c9efe",
  null
  
)

export default component.exports